module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot3-3af07bbdac70d82f92f93f0bd693407f.png";